import axios from '../utils/axios';
import {requests} from '../utils/urls';


const getAllTransaction= async(values,userId,shopId) => {

    try {
        const response = await axios.get(`${requests.management.transaction.getAll}?page=${values.page}&paginate=${values.paginate}&${
            values.type && values.type == 'all' ? '' : `type=${values.type}&`
        }
        ${
            values.payable_type == 'shop' ? `payable_id=${shopId ?? ''}&` : '' || values.payable_type == 'user'  ? `payable_id=${userId ?? ''}&`  : ''
        }
        ${
            values.payable_type && values.payable_type == 'all' ? '' : `payable_type=${values.payable_type}&`
        }${
            values.wallet_name && values.wallet_name == 'all' ? '' : `wallet_name=${values.wallet_name}&`
        }${
            values.reason && values.reason == 'all' ? '' : `reason=${values.reason}&`
        }${
            values.start_date && `start_date=${values.start_date}&`
        }${
            values.end_date && `end_date=${values.end_date}`
        }`);

     

        return response;
    } catch (e) {
        return e.response;
    }
};

const createTransaction = async (values) => {
    try {
        const response = await axios.post(requests.management.transaction.create, values);
        return response;
    } catch (e) {
        return e.response;
    }
};

const transactionsTaxReport = async (values) => {
    try {
        const response = await axios.get(requests.management.transaction.taxReport,{
      responseType: 'blob',
      params: {
        start_date: values.start_date,
        end_date: values.end_date,
      },
    })

        return response;
    } catch (e) {
        return e.response;
    }
};

export {
    getAllTransaction,
    createTransaction ,
    transactionsTaxReport
}